import React, { FunctionComponent, SVGProps, useMemo } from 'react';
import { generateCardStyles } from 'sections/QuickStart/CardStyles';
import { useTheme } from '@emotion/react';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';

interface CardProps {
   title : string;
   icon: FunctionComponent<SVGProps<SVGSVGElement>>;
   url: string;
}

export function Card({ title, icon: Icon, url }: CardProps) {
    const theme = useTheme();
    const styles = useMemo(() => generateCardStyles(theme), [theme]);

    return (
        <Link
            to={url} style={{
                textAlign: 'center',
                padding: '24px 0 0 0',
                transition: 'box-shadow 0.5s ease',
                textDecoration: 'none',
            }}
        >
            <Box sx={styles.iconWrapper}><Icon /></Box>
            <Box component="h4" sx={styles.title}>{title}</Box>
        </Link>
    );
}
